import { defineStore } from "pinia";
import { ActionInternal } from "@/keyboard";

type Cache = { [key: string]: CachedData | undefined };
type CachedData = {
  useHold: boolean;
  useLocal: boolean;
  holdActionCache: ActionInternal | null;
};

export const useActionMenuCacheStore = defineStore("actionMenuCache", {
  state: () => {
    return {} as Cache;
  },

  getters: {
    get(state): (key: string) => CachedData {
      return (key) => {
        let data = state[key];
        if (data == undefined) {
          data = {
            useHold: false,
            useLocal: false,
            holdActionCache: null,
          };
          state[key] = data;
        }
        return data;
      };
    },
  },
});
